module.exports = __webpack_public_path__ + "static/healthier-145466e390c0802ffdbf96f2bd673d9b.png";